/* -------------------------------- GPS assortment Start-------------------------------- */

const carGps = [
  {
    id: "1",
    name: "FMC920",
    type: "carGps",
    img: "/Products/carGps/fmc920qjibo-side-840xAuto.webp",
    portfolio: "GPS کوچک و هوشمند با اتصال 4G Cat 1",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMC920",
    subtitle: "ردیاب پیشرفته با اتصال 4G برای مدیریت ناوگان",
    desc: "ردیاب خودرو FMC920 ساخت شرکت تلتونیکا، یک ردیاب پیشرفته با قابلیت اتصال 4G Cat 1 است که برای مدیریت ناوگان خودروها طراحی شده است. این ردیاب با دقت بالا و سرعت انتقال داده‌های سریع، امکان ردیابی لحظه‌ای و مدیریت هوشمند ناوگان را فراهم می‌کند. FMC920 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMC920 با اتصال 4G Cat 1 و دقت بالا، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
  {
    id: "1",
    name: "FMC640",
    type: "carGps",
    img: "/Products/carGps/FMC640.png",
    portfolio: "ردیاب 4G LTE Cat 1 برای برنامه های حرفه ای",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMC640",
    subtitle: "ردیاب پیشرفته با اتصال 4G برای مدیریت ناوگان",
    desc: "ردیاب خودرو FMC640 ساخت شرکت تلتونیکا، یک ردیاب پیشرفته با قابلیت اتصال 4G Cat 1 است که برای مدیریت ناوگان خودروها طراحی شده است. این ردیاب با دقت بالا و سرعت انتقال داده‌های سریع، امکان ردیابی لحظه‌ای و مدیریت هوشمند ناوگان را فراهم می‌کند. FMC640 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMC640 با اتصال 4G Cat 1 و دقت بالا، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 0,
  },
  {
    id: "1",
    name: "FMC650",
    type: "carGps",
    img: "/Products/carGps/FMC650.webp",
    portfolio:
      "ردیاب 4G LTE Cat 1 برای برنامه های پیشرفته با باتری پشتیبان با ظرفیت بالا و آنتن های خارجی",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMC650",
    subtitle: "ردیاب پیشرفته با اتصال 4G برای مدیریت ناوگان",
    desc: "ردیاب خودرو FMC650 ساخت شرکت تلتونیکا، یک ردیاب پیشرفته با قابلیت اتصال 4G Cat 1 است که برای مدیریت ناوگان خودروها طراحی شده است. این ردیاب با دقت بالا و سرعت انتقال داده‌های سریع، امکان ردیابی لحظه‌ای و مدیریت هوشمند ناوگان را فراهم می‌کند. FMC650 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMC650 با اتصال 4G Cat 1 و دقت بالا، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
  {
    id: "1",
    name: "FMC230",
    type: "carGps",
    img: "/Products/carGps/FMC230.webp",
    portfolio: "ردیاب 4G LTE Cat 1 ضد آب با ورودی های انعطاف پذیر",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMC230",
    subtitle: "ردیاب پیشرفته با اتصال 4G برای مدیریت ناوگان",
    desc: "ردیاب خودرو FMC230 ساخت شرکت تلتونیکا، یک ردیاب پیشرفته با قابلیت اتصال 4G Cat 1 است که برای مدیریت ناوگان خودروها طراحی شده است. این ردیاب با دقت بالا و سرعت انتقال داده‌های سریع، امکان ردیابی لحظه‌ای و مدیریت هوشمند ناوگان را فراهم می‌کند. FMC230 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMC230 با اتصال 4G Cat 1 و دقت بالا، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
  {
    id: "2",
    name: "FMC125",
    type: "carGps",
    img: "https://teltonika-gps.com/cdn/extras/22547/fmc125-side-840xAuto.webp",
    portfolio:
      "ترمینال پیشرفته LTE با اتصال GNSS و LTE/GSM، رابط های RS485/RS232 و باتری پشتیبان.",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMC125",
    subtitle: "ترمینال پیشرفته LTE با قابلیت‌های گسترده",
    desc: "ردیاب خودرو FMC125 ساخت شرکت تلتونیکا، یک ترمینال پیشرفته LTE با اتصال GNSS و LTE/GSM است. این ردیاب با رابط‌های RS485/RS232 و باتری پشتیبان، امکان ردیابی و مدیریت ناوگان خودروها را با دقت بالا فراهم می‌کند. FMC125 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMC125 با اتصال LTE و رابط‌های RS485/RS232، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",

    stock: 1,
  },
  {
    id: "2",
    name: "FMC130",
    type: "carGps",
    img: "/Products/carGps/fmc130.webp",
    portfolio: "ردیاب پیشرفته 4G LTE Cat 1 با ورودی های انعطاف پذیر",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMC130",
    subtitle: "ترمینال پیشرفته LTE با قابلیت‌های گسترده",
    desc: "ردیاب خودرو FMC130 ساخت شرکت تلتونیکا، یک ترمینال پیشرفته LTE با اتصال GNSS و LTE/GSM است. این ردیاب با رابط‌های RS485/RS232 و باتری پشتیبان، امکان ردیابی و مدیریت ناوگان خودروها را با دقت بالا فراهم می‌کند. FMC130 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMC130 با اتصال LTE و رابط‌های RS485/RS232، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",

    stock: 1,
  },
  {
    id: "2",
    name: "FMC150",
    type: "carGps",
    img: "/Products/carGps/fmc150.webp",
    portfolio: "ردیاب GPS پیشرفته 4G LTE Cat 1 با پردازشگر داده CAN یکپارچه",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMC150",
    subtitle: "ترمینال پیشرفته LTE با قابلیت‌های گسترده",
    desc: "ردیاب خودرو FMC150 ساخت شرکت تلتونیکا، یک ترمینال پیشرفته LTE با اتصال GNSS و LTE/GSM است. این ردیاب با رابط‌های RS485/RS232 و باتری پشتیبان، امکان ردیابی و مدیریت ناوگان خودروها را با دقت بالا فراهم می‌کند. FMC150 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMC150 با اتصال LTE و رابط‌های RS485/RS232، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",

    stock: 1,
  },
  {
    id: "3",
    name: "MSP500",
    type: "carGps",
    img: "https://wiki.teltonika-gps.com/images/thumb/6/6e/MSP500_PNG_4000x4000_1.png/300px-MSP500_PNG_4000x4000_1.png",
    portfolio:
      "MSP500 یک ترمینال ردیابی ویژه است که شامل یک زنگ یکپارچه و یک رله برای عملکرد محدود کننده سرعت بر اساس سوئیچینگ منبع تغذیه پمپ بنزین میباشد",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا MSP500",
    subtitle: "ترمینال ردیابی ویژه با قابلیت محدود کننده سرعت",
    desc: "ردیاب خودرو MSP500 ساخت شرکت تلتونیکا، یک ترمینال ردیابی ویژه با قابلیت محدود کننده سرعت است. این ردیاب با طراحی منحصر به فرد و قابلیت سوئیچینگ منبع تغذیه پمپ بنزین، امکان مدیریت هوشمند ناوگان خودروها را فراهم می‌کند. MSP500 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "MSP500 با قابلیت محدود کننده سرعت و طراحی منحصر به فرد، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
  {
    id: "4",
    name: "FMB001",
    type: "carGps",
    img: "/Products/carGps/fmb001-side-840xAuto.webp",
    portfolio:
      "ترمینال ردیابی بی‌درنگ Plug and Track با اتصال GNSS، GSM و بلوتوث",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMB001",
    subtitle: "ردیاب Plug and Track با اتصال GNSS و GSM",
    desc: "ردیاب خودرو FMB001 ساخت شرکت تلتونیکا، یک ترمینال ردیابی بی‌درنگ با اتصال GNSS، GSM و بلوتوث است. این ردیاب با طراحی Plug and Track، امکان نصب سریع و آسان را فراهم می‌کند. FMB001 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMB001 با طراحی Plug and Track و اتصال GNSS و GSM، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 0,
  },
  {
    id: "3",
    name: "FMB003",
    type: "carGps",
    img: "/Products/carGps/FMB003.webp",
    portfolio: "کوچکترین ردیاب 2G ما که کاملاً در هر ماشینی جا می شود",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMB003",
    subtitle: "ترمینال ردیابی ویژه با قابلیت محدود کننده سرعت",
    desc: "ردیاب خودرو FMB003 ساخت شرکت تلتونیکا، یک ترمینال ردیابی ویژه با قابلیت محدود کننده سرعت است. این ردیاب با طراحی منحصر به فرد و قابلیت سوئیچینگ منبع تغذیه پمپ بنزین، امکان مدیریت هوشمند ناوگان خودروها را فراهم می‌کند. FMB003 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMB003 با قابلیت محدود کننده سرعت و طراحی منحصر به فرد، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
  {
    id: "3",
    name: "FMB020",
    type: "carGps",
    img: "/Products/carGps/FMB020.webp",
    portfolio:
      "ردیاب Plug & Play بسیار کوچک 2G برای طیف وسیعی از موارد استفاده",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMB020",
    subtitle: "ترمینال ردیابی ویژه با قابلیت محدود کننده سرعت",
    desc: "ردیاب خودرو FMB020 ساخت شرکت تلتونیکا، یک ترمینال ردیابی ویژه با قابلیت محدود کننده سرعت است. این ردیاب با طراحی منحصر به فرد و قابلیت سوئیچینگ منبع تغذیه پمپ بنزین، امکان مدیریت هوشمند ناوگان خودروها را فراهم می‌کند. FMB020 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMB020 با قابلیت محدود کننده سرعت و طراحی منحصر به فرد، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
  {
    id: "5",
    name: "FMT100",
    type: "carGps",
    img: "/Products/carGps/fmt100-side-840xAuto.webp",
    portfolio: "ردیاب GNSS ضد آب ویژه و کوچک با شتاب سنج داخلی",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMT100",
    subtitle: "ردیاب ضد آب و کوچک با شتاب‌سنج داخلی",
    desc: "ردیاب خودرو FMT100 ساخت شرکت تلتونیکا، یک ردیاب ضد آب و کوچک با شتاب‌سنج داخلی است. این ردیاب با طراحی مقاوم و قابلیت‌های پیشرفته، امکان ردیابی دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. FMT100 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMT100 با طراحی ضد آب و شتاب‌سنج داخلی، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 0,
  },
  {
    id: "6",
    name: "FMB920",
    type: "carGps",
    img: "/Products/carGps/FMB920.png",
    portfolio: "ردیاب GNSS/GSM/Bluetooth با آنتن داخلی GNSS/GSM و باتری داخلی",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMB920",
    subtitle: "ردیاب فشرده با آنتن داخلی GNSS/GSM",
    desc: "ردیاب خودرو FMB920 ساخت شرکت تلتونیکا، یک ردیاب فشرده با آنتن داخلی GNSS/GSM و باتری داخلی است. این ردیاب با طراحی کوچک و قابلیت‌های پیشرفته، امکان ردیابی دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. FMB920 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMB920 با طراحی فشرده و آنتن داخلی GNSS/GSM، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 0,
  },
  {
    id: "7",
    name: "FMB202",
    type: "carGps",
    img: "/Products/carGps/FMB202.png",
    portfolio:
      "ردیاب ضد آب کوچک و حرفه ای با آنتن داخلی GNSS/GSM با بهره بالا، بلوتوث و باتری داخلی Ni-MH با ظرفیت بالا",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMB202",
    subtitle: "ردیاب ضد آب و حرفه‌ای با باتری داخلی",
    desc: "ردیاب خودرو FMB202 ساخت شرکت تلتونیکا، یک ردیاب ضد آب و حرفه‌ای با آنتن داخلی GNSS/GSM و باتری داخلی Ni-MH است. این ردیاب با طراحی مقاوم و قابلیت‌های پیشرفته، امکان ردیابی دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. FMB202 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMB202 با طراحی ضد آب و باتری داخلی Ni-MH، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
  {
    id: "7",
    name: "FMB204",
    type: "carGps",
    img: "/Products/carGps/FMB204.webp",
    portfolio: "ردیاب GPS 2G ضد آب با باتری با ظرفیت بالا",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMB204",
    subtitle: "ردیاب ضد آب و حرفه‌ای با باتری داخلی",
    desc: "ردیاب خودرو FMB204 ساخت شرکت تلتونیکا، یک ردیاب ضد آب و حرفه‌ای با آنتن داخلی GNSS/GSM و باتری داخلی Ni-MH است. این ردیاب با طراحی مقاوم و قابلیت‌های پیشرفته، امکان ردیابی دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. FMB204 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMB204 با طراحی ضد آب و باتری داخلی Ni-MH، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 0,
  },
  {
    id: "7",
    name: "FMB240",
    type: "carGps",
    img: "/Products/carGps/FMB240.webp",
    portfolio: "ردیاب 2G با پوشش ضد آب IP67",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMB240",
    subtitle: "ردیاب ضد آب و حرفه‌ای با باتری داخلی",
    desc: "ردیاب خودرو FMB240 ساخت شرکت تلتونیکا، یک ردیاب ضد آب و حرفه‌ای با آنتن داخلی GNSS/GSM و باتری داخلی Ni-MH است. این ردیاب با طراحی مقاوم و قابلیت‌های پیشرفته، امکان ردیابی دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. FMB240 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMB240 با طراحی ضد آب و باتری داخلی Ni-MH، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
  {
    id: "7",
    name: "FMB230",
    type: "carGps",
    img: "/Products/carGps/FMB230.webp",
    portfolio: "ردیاب 2G ضد آب با ورودی های انعطاف پذیر",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMB230",
    subtitle: "ردیاب ضد آب و حرفه‌ای با باتری داخلی",
    desc: "ردیاب خودرو FMB230 ساخت شرکت تلتونیکا، یک ردیاب ضد آب و حرفه‌ای با آنتن داخلی GNSS/GSM و باتری داخلی Ni-MH است. این ردیاب با طراحی مقاوم و قابلیت‌های پیشرفته، امکان ردیابی دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. FMB230 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMB230 با طراحی ضد آب و باتری داخلی Ni-MH، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 0,
  },
  {
    id: "11",
    name: "FMB120",
    type: "carGps",
    img: "/Products/carGps/FMB120.png",
    portfolio: "ردیاب GNSS/GSM/Bluetooth با آنتن داخلی GNSS/GSM و باتری داخلی",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMB120",
    subtitle: "ردیاب فشرده با آنتن داخلی GNSS/GSM",
    desc: "ردیاب خودرو FMB120 ساخت شرکت تلتونیکا، یک ردیاب فشرده با آنتن داخلی GNSS/GSM و باتری داخلی است. این ردیاب با طراحی کوچک و قابلیت‌های پیشرفته، امکان ردیابی دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. FMB120 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMB120 با طراحی فشرده و آنتن داخلی GNSS/GSM، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
  {
    id: "11",
    name: "FMB122",
    type: "carGps",
    img: "/Products/carGps/FMB122.webp",
    portfolio: "دستگاه ردیاب ضد سرقت 2G برای مدیریت ناوگان",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMB122",
    subtitle: "ردیاب فشرده با آنتن داخلی GNSS/GSM",
    desc: "ردیاب خودرو FMB122 ساخت شرکت تلتونیکا، یک ردیاب فشرده با آنتن داخلی GNSS/GSM و باتری داخلی است. این ردیاب با طراحی کوچک و قابلیت‌های پیشرفته، امکان ردیابی دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. FMB122 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMB122 با طراحی فشرده و آنتن داخلی GNSS/GSM، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
  {
    id: "12",
    name: "FMB130",
    type: "carGps",
    img: "/Products/carGps/fmb130.webp",
    portfolio: "ردیاب پیشرفته 2G با ورودی های انعطاف پذیر",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMB130",
    subtitle: "ردیاب فشرده با آنتن داخلی GNSS/GSM",
    desc: "ردیاب خودرو FMB130 ساخت شرکت تلتونیکا، یک ردیاب فشرده با آنتن داخلی GNSS/GSM و باتری داخلی است. این ردیاب با طراحی کوچک و قابلیت‌های پیشرفته، امکان ردیابی دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. FMB130 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMB130 با طراحی فشرده و آنتن داخلی GNSS/GSM، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
  {
    id: "12",
    name: "FMB140",
    type: "carGps",
    img: "/Products/carGps/fmb140.webp",
    portfolio: "ردیاب 2G با خواننده CAN یکپارچه",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMB140",
    subtitle: "ردیاب فشرده با آنتن داخلی GNSS/GSM",
    desc: "ردیاب خودرو FMB140 ساخت شرکت تلتونیکا، یک ردیاب فشرده با آنتن داخلی GNSS/GSM و باتری داخلی است. این ردیاب با طراحی کوچک و قابلیت‌های پیشرفته، امکان ردیابی دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. FMB140 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMB140 با طراحی فشرده و آنتن داخلی GNSS/GSM، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
  {
    id: "12",
    name: "FMP100",
    type: "carGps",
    img: "/Products/carGps/FMP100.webp",
    portfolio: "ردیاب 2G با خواننده CAN یکپارچه",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMP100",
    subtitle: "ردیاب فشرده با آنتن داخلی GNSS/GSM",
    desc: "ردیاب خودرو FMP100 ساخت شرکت تلتونیکا، یک ردیاب فشرده با آنتن داخلی GNSS/GSM و باتری داخلی است. این ردیاب با طراحی کوچک و قابلیت‌های پیشرفته، امکان ردیابی دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. FMP100 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMP100 با طراحی فشرده و آنتن داخلی GNSS/GSM، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
  {
    id: "12",
    name: "TFT100",
    type: "carGps",
    img: "/Products/carGps/TFT100.webp",
    portfolio:
      "ردیاب 2G با پشتیبانی از ولتاژ بالا برای حمل و نقل الکترونیکی و ماشین آلات سنگین",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا TFT100",
    subtitle: "ردیاب فشرده با آنتن داخلی GNSS/GSM",
    desc: "ردیاب خودرو TFT100 ساخت شرکت تلتونیکا، یک ردیاب فشرده با آنتن داخلی GNSS/GSM و باتری داخلی است. این ردیاب با طراحی کوچک و قابلیت‌های پیشرفته، امکان ردیابی دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. TFT100 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "TFT100 با طراحی فشرده و آنتن داخلی GNSS/GSM، یکی از بهترین ردیاب‌ها برای مدیریت ناوگان خودروهاست. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
  {
    id: "8",
    name: "FMB641",
    type: "carGps",
    img: "/Products/carGps/FMB641.png",
    portfolio: "ترمینال پیشرو GNSS/GSM برای برنامه های پیشرفته",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب خودرو و ناوگان تلتونیکا FMB641",
    subtitle: "ترمینال پیشرو برای برنامه‌های پیشرفته",
    desc: "ردیاب خودرو FMB641 ساخت شرکت تلتونیکا، یک ترمینال پیشرو با اتصال GNSS/GSM برای برنامه‌های پیشرفته است. این ردیاب با طراحی پیشرفته و قابلیت‌های گسترده، امکان ردیابی دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. FMB641 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "FMB641 با طراحی پیشرفته و اتصال GNSS/GSM، یکی از بهترین ردیاب‌ها برای برنامه‌های پیشرفته مدیریت ناوگان است. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
];
const mobolityGps = [
  {
    id: "20",
    name: "TAT100",
    type: "mobolityGps",
    img: "/Products/mobolityGps/tat100-side-840xAuto.webp",
    portfolio:
      "واحد ردیابی برای کالاهای با ارزش، قرقره های سیم، ابزار، تجهیزات ساختمانی، کانتینرها، واگن ها، بالابرهای قیچی و بسیاری دیگر از دارایی های غیر برقی مناسب است.",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب دارایی‌های متحرک تلتونیکا TAT100",
    subtitle: "ردیاب ضد آب و مقاوم برای دارایی‌های با ارزش",
    desc: "ردیاب TAT100 ساخت شرکت تلتونیکا، یک ردیاب ضد آب و مقاوم برای ردیابی دارایی‌های با ارزش مانند قرقره‌های سیم، ابزار، تجهیزات ساختمانی، کانتینرها و واگن‌ها است. این ردیاب با طراحی مستحکم و مقاوم در برابر شرایط سخت محیطی، امکان ردیابی دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAT100 انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAT100 با طراحی ضد آب و مقاوم، یکی از بهترین ردیاب‌ها برای ردیابی دارایی‌های با ارزش است. این ردیاب با دقت بالا و مقاومت در برابر شرایط سخت، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
  {
    id: "10",
    name: "TMT250",
    type: "mobolityGps",
    img: "/Products/carGps/tmt250.webp",
    portfolio:
      "Teltonika TMT250 یک ردیاب شخصی مستقل با اتصال GNSS، GSM و بلوتوث است.",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب شخصی تلتونیکا TMT250",
    subtitle: "ردیاب مستقل با اتصال GNSS و GSM",
    desc: "ردیاب شخصی TMT250 ساخت شرکت تلتونیکا، یک ردیاب مستقل با اتصال GNSS، GSM و بلوتوث است. این ردیاب با طراحی کوچک و قابلیت‌های پیشرفته، امکان ردیابی دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TMT250 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TMT250 با طراحی مستقل و اتصال GNSS و GSM، یکی از بهترین ردیاب‌ها برای ردیابی دارایی‌های متحرک است. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
  {
    id: "11",
    name: "GH5200",
    type: "mobolityGps",
    img: "/Products/mobolityGps/GH5200.webp",
    portfolio: "GH5200 یک ردیاب شخصی خودکار با GNSS، GSM واتصال بلوتوث است",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "ردیاب شخصی تلتونیکا GH5200",
    subtitle: "ردیاب خودکار با اتصال GNSS و GSM",
    desc: "ردیاب شخصی GH5200 ساخت شرکت تلتونیکا، یک ردیاب خودکار با اتصال GNSS، GSM و بلوتوث است. این ردیاب با طراحی کوچک و قابلیت‌های پیشرفته، امکان ردیابی دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. GH5200 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "GH5200 با طراحی خودکار و اتصال GNSS و GSM، یکی از بهترین ردیاب‌ها برای ردیابی دارایی‌های متحرک است. این ردیاب با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
];
const gpsAccessories = [
  {
    id: "10",
    name: "TELTOCHARGE",
    type: "gpsAccessories",
    img: "https://wiki.teltonika-energy.com/images/0/00/TeltoCharge_Charger_main.png",
    portfolio:
      "شارژر EV آسان، هوشمند و قابل اعتماد که می توانید آن را مطابق با نیاز خود سفارشی کنید",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "شارژر هوشمند تلتونیکا TELTOCHARGE",
    subtitle: "شارژر EV قابل اعتماد و قابل سفارشی‌سازی",
    desc: "شارژر هوشمند TELTOCHARGE ساخت شرکت تلتونیکا، یک شارژر EV قابل اعتماد و قابل سفارشی‌سازی است که برای شارژ خودروهای الکتریکی طراحی شده است. این شارژر با قابلیت‌های هوشمند و اتصال به شبکه، امکان مدیریت مصرف انرژی و بهینه‌سازی فرآیند شارژ را فراهم می‌کند. TELTOCHARGE انتخابی ایده‌آل برای مالکان خودروهای الکتریکی و شرکت‌های ارائه‌دهنده خدمات شارژ است.",
    review:
      "TELTOCHARGE با قابلیت‌های هوشمند و قابل سفارشی‌سازی، یکی از بهترین شارژرهای EV در بازار است. این شارژر با مدیریت مصرف انرژی و بهینه‌سازی فرآیند شارژ، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "11",
    name: "EYE BEACON",
    type: "gpsAccessories",
    img: "/Products/gpsAccessories/EyeSensor.png",
    portfolio:
      "مدل های چراغ و سنسور ID کم انرژی بلوتوث با بدنه محکم و باتری با عمر طولانی",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "چراغ و سنسور تلتونیکا EYE BEACON",
    subtitle: "چراغ و سنسور کم انرژی با عمر باتری طولانی",
    desc: "چراغ و سنسور EYE BEACON ساخت شرکت تلتونیکا، یک مدل چراغ و سنسور ID کم انرژی بلوتوث با بدنه محکم و باتری با عمر طولانی است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. EYE BEACON انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "EYE BEACON با طراحی مقاوم و عمر باتری طولانی، یکی از بهترین چراغ‌ها و سنسورهای ID در بازار است. این محصول با قابلیت‌های پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "12",
    name: "DUALCAM",
    type: "gpsAccessories",
    img: "https://teltonika-gps.com/cdn/extras/11100/dualcam-840xAuto.webp",
    portfolio:
      "FMC125 و یک راه حل دوربین برای نظارت تصویری در داخل کابین و جاده",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "دوربین دوگانه تلتونیکا DUALCAM",
    subtitle: "راه‌حل نظارت تصویری برای داخل کابین و جاده",
    desc: "دوربین دوگانه DUALCAM ساخت شرکت تلتونیکا، یک راه‌حل نظارت تصویری برای داخل کابین و جاده است. این محصول با طراحی پیشرفته و قابلیت‌های گسترده، امکان نظارت دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. DUALCAM انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "DUALCAM با طراحی پیشرفته و قابلیت‌های گسترده، یکی از بهترین دوربین‌های نظارتی در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "13",
    name: "ADAS",
    type: "gpsAccessories",
    img: "https://wiki.teltonika-gps.com/images/thumb/b/bf/MDAS-9_2.jpg/500px-MDAS-9_2.jpg",
    portfolio:
      "دوربین ADAS برای جلوگیری از برخورد و تصادف با قابلیت نظارت بصری طراحی شده است",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "دوربین ADAS تلتونیکا",
    subtitle: "دوربین نظارتی برای جلوگیری از برخورد و تصادف",
    desc: "دوربین ADAS ساخت شرکت تلتونیکا، یک دوربین نظارتی برای جلوگیری از برخورد و تصادف با قابلیت نظارت بصری است. این محصول با طراحی پیشرفته و قابلیت‌های گسترده، امکان نظارت دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. ADAS انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "ADAS با طراحی پیشرفته و قابلیت‌های گسترده، یکی از بهترین دوربین‌های نظارتی در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
    stock: 1,
  },
  {
    id: "14",
    name: "LV-CAN200",
    type: "gpsAccessories",
    img: "https://teltonika-gps.com/cdn/extras/10998/lv-can200-840xAuto.webp",
    portfolio:
      "آداپتور CAN برای خواندن داده های CAN bus از خودروهای سواری، وسایل نقلیه تجاری سبک، کامیون ها و اتوبوس ها",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "آداپتور CAN تلتونیکا LV-CAN200",
    subtitle: "آداپتور CAN برای خواندن داده‌های CAN bus",
    desc: "آداپتور CAN LV-CAN200 ساخت شرکت تلتونیکا، یک آداپتور CAN برای خواندن داده‌های CAN bus از خودروهای سواری، وسایل نقلیه تجاری سبک، کامیون‌ها و اتوبوس‌ها است. این محصول با طراحی پیشرفته و قابلیت‌های گسترده، امکان نظارت دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. LV-CAN200 انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    review:
      "LV-CAN200 با طراحی پیشرفته و قابلیت‌های گسترده، یکی از بهترین آداپتورهای CAN در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "15",
    name: "PRIEDASH",
    type: "gpsAccessories",
    img: "https://voip.world/media/image/product/3584/lg/teltonika-tmt250-quarantine-monitoring-solution-tragbares-armband-mit-gps-ortung-zur-quarantaene-taeterueberwachung-mit-manipulationserkennung-alarmtaste-und-bewegungssperre.jpg",
    portfolio: "نگهدارنده TMT250",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
];
/* --------------------------------- GPS assortment End---------------------------------- */
/* -------------------------------- CCTV assortment Start-------------------------------- */

const ipCamera = [
  {
    id: "20",
    name: "RN-525-IP-R4-T5",
    type: "ipCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/014-1-scaled.jpg",
    portfolio:
      "1/3 Progressive Scan CMOS - Ai  هوش مصنوعی- بدنه فلزی - محیط بیرونی - ضد آب میکروفن داخلی",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-525-IP-S4-T5",
    type: "ipCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/014-1-scaled.jpg",
    portfolio:
      "دید در شب رنگی WARM -LIGHT ۳۰متر 1/3 Progressive Scan CMOS - Ai  هوش مصنوعی- بدنه فلزی - محیط بیرونی - ضد آب میکروفن داخلی",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-525-IPM-D4-T3",
    type: "ipCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/014-1-scaled.jpg",
    portfolio:
      "دید در شب DUAL 1/3 Progressive Scan CMOS - Ai  هوش مصنوعی- بدنه فلزی - محیط بیرونی - ضد آب میکروفن داخلی",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-525-IP-S5-T1",
    type: "ipCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/014-1-scaled.jpg",
    portfolio:
      " خروجی اسپیکر - 1/3 Progressive Scan CMOS - Ai  هوش مصنوعی- بدنه فلزی - محیط بیرونی - ضد آب میکروفن داخلی",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-560-IP-R4-T5",
    type: "ipCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/Figure5-600x600.jpg",
    portfolio:
      "بدنه فلزی - محیط بیرونی - ضد آب میکروفن داخلی- دید در شب - ۳۰ متر Infrared",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-560-IP-D4-T5",
    type: "ipCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/Figure5-600x600.jpg",
    portfolio: "بدنه فلزی - محیط بیرونی - ضد آب میکروفن داخلی دید در شب DUAL",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-565-IP-S4-T5",
    type: "ipCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/Figure1-2-1200x1200.jpg",
    portfolio:
      "بدنه فلزی - محیط بیرونی - ضد آب میکروفن داخلی دید در شب رنگی WARM - LIGHT ۳۰متر",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-565-IPM-D4-T3",
    type: "ipCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/Figure1-2-1200x1200.jpg",
    portfolio:
      "بدنه فلزی - محیط بیرونی - ضد آب میکروفن داخلی 64 گیگ حافظه داخلی خروجی اسپیکر - دید در شب DUAL",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-565-IP-R5-T1",
    type: "ipCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/Figure1-2-1200x1200.jpg",
    portfolio:
      "بدنه فلزی - محیط بیرونی - ضد آب میکروفن داخلی - دید در شب - Infrared 4۰متر",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-565-IP-D5-T1",
    type: "ipCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/Figure1-2-1200x1200.jpg",
    portfolio: "بدنه فلزی - محیط بیرونی - ضد آب میکروفن داخلی - دید در شب DUAL",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-565-IP-S5-T1",
    type: "ipCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/Figure1-2-1200x1200.jpg",
    portfolio:
      "بدنه فلزی - محیط بیرونی - ضد آب میکروفن داخلی -دید در شب رنگی StarLight",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-580-IP-S5-ZT1",
    type: "ipCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/Figure2-3-1200x1200.jpg",
    portfolio:
      "بدنه فلزی - محیط بیرونی - ضد آب میکروفن داخلی - دید در شب رنگی Super StarLight",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-580-IP-D5-ZT1",
    type: "ipCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/Figure2-3-1200x1200.jpg",
    portfolio: "بدنه فلزی - محیط بیرونی - ضد آب میکروفن داخلی - دید در شب DUAL",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-580-IP-S8-ZT1",
    type: "ipCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/Figure2-3-1200x1200.jpg",
    portfolio:
      "بدنه فلزی - محیط بیرونی - ضد آب - میکروفن داخلی - 8 مگاپیکسل 4k - دید در شب رنگی Super Star Light",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-667-IP-R4-T5",
    type: "ipCamera",
    img: "/Products/cctvIpCamera/RN-667-IP-R4-T5.jpg",
    portfolio:
      "بدنه فلزی - محیط داخلی میکروفن داخلی - 4 مگاپیکسل - دید در شب - 30 متر infrared",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-665-IP-S4-T5",
    type: "ipCamera",
    img: "/Products/cctvIpCamera/RN-665-IP-S4-T5.jpg",
    portfolio:
      "بدنه فلزی - محیط داخلی میکروفن داخلی - 4 مگاپیکسل - دید در شب warm light - 30 متر ",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-680-IPM-D4-T3",
    type: "ipCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/60A1161-scaled.jpg",
    portfolio:
      "بدنه فلزی - محیط داخلی میکروفن داخلی 64 گیگ حافظه داخلی - خروجی اسپیکر - 5 مگاپیکسل - ب DUAL",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-670-IP-S5-T1",
    type: "ipCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/Figure2-1-600x600.jpg",
    portfolio:
      "بدنه فلزی - محیط داخلی میکروفن داخلی - اسپیکر خروجی - دید در شب DUAL",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-6620-IP-PTZ",
    type: "ipCamera",
    img: "/Products/cctvIpCamera/RN-6620-IP-PTZ.jpg",
    portfolio:
      "بدنه فلزی و پالستیک - محیط بیرونی - ضد آب میکروفن داخلی - دید در شب - DUAL LAZER LED",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-6533-IP-PTZ",
    type: "ipCamera",
    img: "/Products/cctvIpCamera/RN-6533-IP-PTZ.jpg",
    protofilo:
      "بدنه فلزی و پالستیک - محیط بیرونی - ضد آب میکروفن داخلی اسپیکر داخلی - 5 مگاپیکسل - دید در شب - DUAL LAZER LED",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-6633-IP-PTZ",
    type: "ipCamera",
    img: "/Products/cctvIpCamera/RN-6620-IP-PTZ.png",
    protofilo:
      "بدنه فلزی و پالستیک - محیط بیرونی - ضد آب میکروفن داخلی اسپیکر داخلی - 5 مگاپیکسل - دید در شب - DUAL LAZER LED",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-6922-IP-PTZ",
    type: "ipCamera",
    img: "/Products/cctvIpCamera/RN-6922-IP-PTZ.jpg",
    protofilo:
      "بدنه فلزی و پالستیک - محیط بیرونی - ضد آب میکروفن داخلی اسپیکر داخلی - 5 مگاپیکسل - دید در شب - DUAL LAZER LED ",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-6933-IP-PTZ",
    type: "ipCamera",
    img: "/Products/cctvIpCamera/RN-6922-IP-PTZ.jpg",
    protofilo:
      "بدنه فلزی و پالستیک - محیط بیرونی - ضد آب میکروفن داخلی اسپیکر داخلی - 5 مگاپیکسل - دید در شب - DUAL LAZER LED - با زوم بیشتر",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
];

const ipRecorder = [
  {
    id: "20",
    name: "RN-9216R",
    type: "ipRecorder",
    img: "/Products/cctvIpRecorder/RN-9216R.png",
    protofilo:
      " P6 light P2P - دستگاه ضبط تصاویرتحت شبکه - 16 کانال - 1 هارد حد اکثر ظرفیت 8TB",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-9232R",
    type: "ipRecorder",
    img: "/Products/cctvIpRecorder/RN-9216R.png",
    protofilo:
      " P6 light P2P - دستگاه ضبط تصاویرتحت شبکه - 32 کانال - 2 هارد حد اکثر ظرفیت 8TB",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-9110T5",
    type: "ipRecorder",
    img: "/Products/cctvIpRecorder/RN-9216R.png",
    protofilo:
      "IE SeeTong P2P - دستگاه ضبط تصاویرتحت شبکه - 10 کانال - 1 هارد حد اکثر ظرفیت 8TB",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-9116T5",
    type: "ipRecorder",
    img: "/Products/cctvIpRecorder/RN-9216R.png",
    protofilo:
      "IE SeeTong P2P - دستگاه ضبط تصاویرتحت شبکه - 16 کانال - 1 هارد حد اکثر ظرفیت 8TB",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-9132T5",
    type: "ipRecorder",
    img: "/Products/cctvIpRecorder/RN-9216R.png",
    protofilo:
      "IE SeeTong P2P - دستگاه ضبط تصاویرتحت شبکه - 32 کانال - 2 هارد حد اکثر ظرفیت 8TB",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-9136T5",
    type: "ipRecorder",
    img: "/Products/cctvIpRecorder/RN - 9164T5.png",
    protofilo:
      "IE SeeTong P2P - دستگاه ضبط تصاویرتحت شبکه - 36 کانال - 8 هارد حد اکثر ظرفیت 8TB",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-9164T5",
    type: "ipRecorder",
    img: "/Products/cctvIpRecorder/RN - 9164T5.png",
    protofilo:
      "IE SeeTong P2P - دستگاه ضبط تصاویرتحت شبکه - 64 کانال - 8 هارد حد اکثر ظرفیت 8TB",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
];
const ipCctvSwitches = [
  {
    id: "20",
    name: "2+5 switch",
    type: "ipCctvSwitches",
    img: "/Products/ipCctvSwitches/25switch.jpg",
    protofilo: "سوییچ 4+2 - فلزی - 220 ولت ",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "2+5 switch",
    type: "ipCctvSwitches",
    img: "/Products/ipCctvSwitches/28switch.jpg",
    protofilo: "سوییچ 8+2 - فلزی - 220 ولت ",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "2+5 switch",
    type: "ipCctvSwitches",
    img: "/Products/ipCctvSwitches/28switch.jpg",
    protofilo: "سوییچ 8+2 - فلزی - 220 ولت ",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "2+16 switch",
    type: "ipCctvSwitches",
    img: "/Products/ipCctvSwitches/216switch.jpg",
    protofilo: "سوییچ 16+2 - فلزی رکموند - 220 ولت ",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "2+24 switch",
    type: "ipCctvSwitches",
    img: "/Products/ipCctvSwitches/216switch.jpg",
    protofilo: "سوییچ 24+2 - فلزی - 220 ولت ",
    specifications: {
      status1: "3200g",
      status2: "35x12x20",
      status3: "آنتن داخلی",
      status4: "سیمکارت خور",
      status5: "دما سنج",
      status6: "ضد آب",
    },

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
];
const ahdCamera = [
  {
    id: "20",
    name: "RN-661-HD-R2-H1",
    type: "ahdCamera",
    img: "/Products/ahdCamera/RN-661-HD-R2-H1.jpg",
    protofilo:
      "بدنه پلاستیکی - 2 مگاپیکسل - 25 فریم بر ثانیه - دید در شب -30 متر Infrared",

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN-525-HD-R2-H1",
    type: "ahdCamera",
    img: "/Products/ahdCamera/RN-525-HD-R2-H1.jpg",
    protofilo:
      "بدنه فلزی ضد آب - 2 مگاپیکسل - 25 فریم بر ثانیه - دید در شب -30 متر Infrared",

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN-525-HD-S2-H1",
    type: "ahdCamera",
    img: "/Products/ahdCamera/RN-525-HD-R2-H1.jpg",
    protofilo:
      "بدنه فلزی ضد آب - 2 مگاپیکسل - 25 فریم بر ثانیه - دید در شب رنگی مترWARM - LIGHT 30 ",

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN-525-HD-S5-H1",
    type: "ahdCamera",
    img: "/Products/ahdCamera/RN-525-HD-R2-H1.jpg",
    protofilo:
      "بدنه فلزی ضد آب - 5 مگاپیکسل - 25 فریم بر ثانیه - دید در شب رنگی مترWARM - LIGHT 30 ",

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN-560-HD-R2-H1",
    type: "ahdCamera",
    img: "/Products/ahdCamera/RN-560-HD-R2-H1.jpg",
    protofilo:
      "بدنه فلزی ضد آب - 2 مگاپیکسل - 25 فریم بر ثانیه - دید در شب -40 متر Infrared",

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN-560-HD-S2-H1",
    type: "ahdCamera",
    img: "/Products/ahdCamera/RN-560-HD-R2-H1.jpg",
    protofilo:
      "بدنه فلزی ضد آب - 2 مگاپیکسل - 25 فریم بر ثانیه - دید در شب - Infrared متر 40",

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN-560-TVI-S2-N3",
    type: "ahdCamera",
    img: "/Products/ahdCamera/RN-560-HD-R2-H1.jpg",
    protofilo:
      "بدنه فلزی ضد آب  میکروفن داخلی(انتقال صدا با کواکسیال) - 2 مگاپیکسل - 25 فریم بر ثانیه - دید در شب - Infrared متر 40",

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN-565-HD-R5-H1",
    type: "ahdCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/10/Figure1-600x600.jpg",
    protofilo:
      "بدنه فلزی ضد آب - 5 مگاپیکسل - 25 فریم بر ثانیه - دید در شب رنگی متر WARM - LIGHT 40 ",

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN-565-HD-R5-H1",
    type: "ahdCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/10/Figure1-600x600.jpg",
    protofilo:
      "بدنه فلزی ضد آب  میکروفن داخلی(انتقال صدا با کواکسیال) - 5 مگاپیکسل - 25 فریم بر ثانیه - دید در شب - Infrared متر 40",

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN-565-HD-R5-H1",
    type: "ahdCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/10/Figure1-600x600.jpg",
    protofilo:
      "بدنه فلزی ضد آب - 5 مگاپیکسل - 25 فریم بر ثانیه - دید در شب رنگی متر WARM - LIGHT 40 ",

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN-580-HD-S5-VH1",
    type: "ahdCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/Figure2-3-1200x1200.jpg",
    protofilo:
      "فلزی بدنه - محیط بیرونی - ضد آب - 5 مگاپیکسل - 25 فریم بر ثانیه - دید در شب - دید در شب رنگی WARM LIGHT - متر۴۰ ",

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN-665-HD-R2-H1",
    type: "ahdCamera",
    img: "/Products/cctvIpCamera/RN-665-IP-S4-T5.jpg",
    protofilo:
      "فلزی بدنه ضد ضربه محیط داخلی - ضد آب - 2 مگاپیکسل - 25 فریم بر ثانیه - دید در شب - دید در شب - 30 متر Infrared ",

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN-667-HD-S2-H1",
    type: "ahdCamera",
    img: "/Products/cctvIpCamera/RN-667-IP-R4-T5.jpg",
    protofilo:
      "فلزی بدنه - محیط بیرونی - ضد آب -2 مگاپیکسل - 25 فریم بر ثانیه - دید در شب - دید در شب رنگی WARM LIGHT - متر30 ",

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN-670-TVI-S2-N3",
    type: "ahdCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/Figure2-1-600x600.jpg",
    protofilo:
      "بدنه فلزی ضد ضربه محیط داخلی میکروفن داخلی - 2 مگاپیکسل - دید در شب رنگی WARM - LIGHT 30 متر",

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN-670-HD-R5-H1",
    type: "ahdCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/Figure2-1-600x600.jpg",
    protofilo: "بدنه فلزی ضد ضربه محیط داخلی  - 5 مگاپیکسل - infrared 30متر",
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },

  {
    id: "20",
    name: "RN-680-TVI-S5-N2",
    type: "ahdCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/60A1161-scaled.jpg",
    protofilo:
      "بدنه فلزی ضد ضربه محیط داخلی - میکروفن داخلی - 5  مگاپیکسل - دید در شب - دید در شب رنگی WARM - LIGHT 30 متر",

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN-680-HD-S5-H1",
    type: "ahdCamera",
    img: "https://revisioncctv.com/wp-content/uploads/2022/09/60A1161-scaled.jpg",
    protofilo:
      "بدنه فلزی ضد ضربه محیط داخلی  - 5  مگاپیکسل - دید در شب - دید در شب رنگی WARM - LIGHT 30 متر",

    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
];
const ahdRecorder = [
  {
    id: "20",
    name: "RN-8104-N5-HI",
    type: "ahdRecorder",
    img: "/Products/ahdRecorder/RN -8104-N5-HI.png",
    protofilo:
      "دستگاه ضبط تصاویر هیبرید - 4 کاناله HVR - تعداد هارد 1 - حداکثر ظرفیت 8TB - نرم افزار xm",
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN -8104-H5-NA",
    type: "ahdRecorder",
    img: "/Products/ahdRecorder/RN -8104-N5-HI.png",
    protofilo:
      "دستگاه ضبط تصاویر هیبرید TVI  - 4 کاناله HVR - تعداد هارد 1 - حداکثر ظرفیت 8TB - نرم افزار P6S",
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN-8108-N5-NT",
    type: "ahdRecorder",
    img: "/Products/ahdRecorder/RN -8104-N5-HI.png",
    protofilo:
      "دستگاه ضبط تصاویر هیبرید - 8 کاناله HVR - تعداد هارد 1 - حداکثر ظرفیت 8TB - نرم افزار xm",
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN -8108-H5-NA",
    type: "ahdRecorder",
    img: "/Products/ahdRecorder/RN -8104-N5-HI.png",
    protofilo:
      "دستگاه ضبط تصاویر هیبرید TVI - 8 کاناله HVR - تعداد هارد 1 - حداکثر ظرفیت 8TB - نرم افزار P6S",
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN -8116-N5-NT",
    type: "ahdRecorder",
    img: "/Products/ahdRecorder/RN -8104-N5-HI.png",
    protofilo:
      "دستگاه ضبط تصاویر هیبرید - 16 کاناله HVR - تعداد هارد 2 - حداکثر ظرفیت 8TB - نرم افزار xm",
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
  {
    id: "20",
    name: "RN -8132-N5-NT",
    type: "ahdRecorder",
    img: "/Products/ahdRecorder/RN -8104-N5-HI.png",
    protofilo:
      "دستگاه ضبط تصاویر هیبرید - 32 کاناله HVR - تعداد هارد 2 - حداکثر ظرفیت 8TB - نرم افزار xm",
    title: "نگهدارنده تلتونیکا TAMPER WRISTBAND",
    subtitle: "نگهدارنده TMT250 با قابلیت تشخیص دستکاری",
    desc: "نگهدارنده TAMPER WRISTBAND ساخت شرکت تلتونیکا، یک نگهدارنده TMT250 با قابلیت تشخیص دستکاری است. این محصول با طراحی مقاوم و قابلیت‌های پیشرفته، امکان نظارت دقیق و مدیریت دارایی‌های متحرک را فراهم می‌کند. TAMPER WRISTBAND انتخابی ایده‌آل برای شرکت‌های ساختمانی و حمل و نقل است.",
    review:
      "TAMPER WRISTBAND با طراحی مقاوم و قابلیت تشخیص دستکاری، یکی از بهترین نگهدارنده‌ها در بازار است. این محصول با قابلیت‌های امنیتی پیشرفته، اطمینان خاطر را برای کاربران فراهم می‌کند.",
  },
];
/* -------------------------------- CCTV assortment End-------------------------------- */

// const gpsAssortment = [...carGps, ...mobolityGps, ...gpsAccessories];
// const IPCCTV = [...ipCamera, ...ipRecorder, ...ipCctvSwitches];
// const AHDCCTV = [...ahdCamera, ...ahdRecorder];
// const CCTV = [...IPCCTV, ...AHDCCTV];
// const allProducts = [...gpsAssortment, ...CCTV];

const products = [
  {
    id: 0,
    name: "Products",
    title: "تمامی محصولات",
    childs: [
      {
        id: 1,
        name: "gpsAssortments",
        title: "مکان‌یاب (GPS)",
        childs: [
          { id: 3, name: "carGps", list: carGps, title: "مکان‌یاب خودرو" },
          {
            id: 4,
            name: "mobolityGps",
            list: mobolityGps,
            title: "مکان‌یاب شخصی",
          },
          {
            id: 5,
            name: "gpsAccessories",
            list: gpsAccessories,
            title: "لوازم جانبی مکان‌یاب",
          },
        ],
      },
      {
        id: 2,
        name: "CCTV",
        title: "دوربین مداربسته (CCTV)",
        childs: [
          {
            id: 6,
            name: "IPCCTV",
            title: "دوربین تحت شبکه(IP)",
            childs: [
              { id: 8, name: "ipCamera", list: ipCamera, title: "دوربین" },
              {
                id: 9,
                name: "ipRecorder",
                list: ipRecorder,
                title: "دستگاه ضبط تحت شبکه",
              },
              {
                id: 10,
                name: "ipCctvSwitches",
                list: ipCctvSwitches,
                title: "سوویچ",
              },
            ],
          },
          {
            id: 7,
            name: "AHDCCTV",
            title: "دوربین مداربسته(AHD)",
            childs: [
              { id: 11, name: "ahdCamera", list: ahdCamera, title: "دوربین" },
              {
                id: 12,
                name: "ahdRecorder",
                list: ahdRecorder,
                title: "دستگاه ضبط تصاویر هیبرید",
              },
            ],
          },
        ],
      },
    ],
  },
];

export default products;
